import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetMasterComponent } from './pages/widget-master/widget-master.component';
import { RouterModule } from '@angular/router';
import { ButtonsModule } from '../shared/components/buttons/buttons.module';
import { HttpsValidationComponent } from './components/https-validation/https-validation.component';
import { WarningMessageComponent } from './components/warning-message/warning-message.component';
import { IconModule } from '../shared/components/icon/icon.module';
import { IeWarningComponent } from './components/ie-warning/ie-warning.component';
import { DirectivesModule } from '../shared/directives/directives.module';



@NgModule({
  declarations: [WidgetMasterComponent, HttpsValidationComponent, WarningMessageComponent, IeWarningComponent],
  imports: [
    CommonModule,
    RouterModule,
    ButtonsModule,
    DirectivesModule,
    IconModule
  ],
  exports: [WidgetMasterComponent]
})
export class WidgetModule { }
